import yup from '../../../config/yup';

export const zoomReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('zoomReader'),
  delayedRead: yup.boolean(),
  onError: yup.string(),
  connectionKey: yup.string(),
  parameterizedBy: yup.string(),
  properties: yup.object().shape({
    path: yup.string().required('Path is required'),
  }),
});
